import { Link } from 'gatsby';
import styled from 'styled-components';
import {
  headLine4,
  headLine5,
  hoverEffect,
  hoverImageEffect,
  lineClamp,
  linkText,
} from '../../theme/GlobalStyle';

export const TrendingNewsCardContainer = styled.div`
  width: 100%;
  padding: 5px 0;
  margin: 0 0 15px;
  display: block;
  transition: all 0.4s ease;
  .card-content {
    padding-bottom: 5px;
    .content {
      color: ${(props) => props.theme.color.textLight};
      ${headLine4}
      ${lineClamp()};
      ${hoverEffect()}
      @media (max-width: 1300px) {
        ${headLine5};
      }
    }
    @media (max-width: 576px) {
      width: 100%;
      display: block;
      .content {
        flex-basis: 72%;
      }
    }
  }
`;
export const CardImage = styled(Link)`
  width: 100%;
  padding-top: 8px;

  @media (max-width: 576px) {
    width: 100%;
  }
`;

export const TrendingNewsImage = styled.figure`
  margin: 0;
  position: relative;
  cursor: pointer;
  ${hoverImageEffect()}

  @media (max-width: 995px) {
    flex-basis: 30%;
  }
  @media (max-width: 576px) {
    flex-basis: 25%;
  }
`;

export const Author = styled.div`
  margin: 8px 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  color: ${(props) => props.theme.color.textLight};
  ${linkText};

  a {
    color: ${(props) => props.theme.color.bgPrimary};
    transition: text-decoration ease-in-out 0.2s;
  }

  .author-container {
    margin: 0 5px 0 0;
  }
  .divider {
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 100%;
    margin: 0 8px 0 6px;
    background-color: ${(props) => props.theme.color.textLight};
  }

  @media (min-width: 1024px) {
    a:hover {
      color: ${(props) => props.theme.color.bgPrimary};
      text-decoration: underline;
    }
  }
`;

export const CardContent = styled.div`
  display: block;
  flex-basis: 70%;
  margin: 15px 0 0;
  color: ${(props) => props.theme.color.textLight};
  ${headLine4};
`;
